import { render, staticRenderFns } from "./SoundCouplesForm.vue?vue&type=template&id=11da15de&scoped=true&lang=pug&"
import script from "./SoundCouplesForm.vue?vue&type=script&lang=js&"
export * from "./SoundCouplesForm.vue?vue&type=script&lang=js&"
import style0 from "./SoundCouplesForm.vue?vue&type=style&index=0&id=11da15de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11da15de",
  null
  
)

export default component.exports